import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { objectAvailabilityDetailsPropType } from './object-availability-details-prop-type'
import { objectAvailabilityStatusPropType } from './object-availability-status-prop-type'

/**
 * @typedef {Object} ObjectAvailability
 * @property {ObjectAvailabilityDetails} availabilityDetails - The availability details of an object
 * @property {ObjectAvailabilityStatus} availabilityStatus - The availability status of an object
 * @property {ISO8601} lastModified - The last-modified timestamp of the object
 * @property {Id} objectId - The ID of the object
 */
export const objectAvailabilityPropType = PropTypes.shape({
    availabilityDetails: objectAvailabilityDetailsPropType,
    availabilityStatus: objectAvailabilityStatusPropType,
    lastModified: PropTypes.number,
    objectId: idPropType
})
